<!--箱子扫码入仓--->
<template>
    <div class="business-content-main" v-loading="loading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">扫码</div>
                <el-input
                    ref="inputdata"
                    v-model="scanData"
                    clearable
                    :placeholder="phholder"
                    size="small"
                    style="width: 250px"
                    @blur="inputblur()"
                    @change="inputDataChange()"
                    class="search-name"
                ></el-input>
                <el-button size="small" class="search-btn btn-primary" :disabled="loading" @click="submit()">提交入仓</el-button>
                <div v-if="boxCode" class="search-name">箱子：{{ boxCode }}</div>
                <div class="search-name" style="color: red">请先扫箱子标签，后扫商品标签。（确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）</div>
            </div>
        </div>
        <div>
            <el-row :gutter="20" class="table-ctn">
                <el-col :span="20">
                    <div class="grid-content">
                        <el-table :header-cell-style="{ background: '#F2F6FC' }" border="" :data="dataList" style="width: 100%">
                            <el-table-column label="标签编码" show-overflow-tooltip min-width="100px" prop="LabelCode"></el-table-column>
                            <el-table-column label="汽配编码" show-overflow-tooltip min-width="100px" prop="APCode"></el-table-column>
                            <el-table-column label="汽配名称" show-overflow-tooltip min-width="100px" prop="GoodsName"></el-table-column>
                            <el-table-column label="适用车型" show-overflow-tooltip prop="AutoSerise"></el-table-column>
                            <el-table-column label="商品数量" show-overflow-tooltip width="80px" prop="PackingSpec"></el-table-column>
                            <el-table-column label="所在仓位" show-overflow-tooltip min-width="100px" prop="SpaceCode"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" style="color: red" @click="removeLabel(scope.$index, scope.row)">移除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
            </el-row>
            <audio ref="audio" controls hidden></audio>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
export default {
    name: 'goodsScanIn',
    components: {
        breadcrumb
    },
    data() {
        return {
            phholder: '',
            loading: false,
            dataList: [],
            scanData: '',
            boxId: '',
            boxCode: '',
            firstScanSpace: true,
            currectAudio: '/download/currect.mp3',
            errorAudio: '/download/error.mp3',
            allOutAudio: '/download/allout.mp3',
            wrongXSAudio: '/download/wrongxs.mp3',
            repetLabel: '/download/repetlabel.mp3',
            enoughAudio: '/download/enough.mp3',
            autoSubmitAudio: '/download/autosubmit.mp3',
            recordPickerAudio: '/download/lrjhy.mp3',
            changePickerAudio: '/download/ggjhy.mp3',
            checkPickerAudio: '/download/checkpicker.mp3',
            submitSuccessAudio: '/download/submitsuccess.mp3'
        };
    },
    created() {},
    mounted() {
        let that = this;
        that.phholder = '请扫箱子标签';
    },
    methods: {
        checkBoxForGoodsStor() {
            let that = this;
            this.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpBoxes/CheckBoxForGoodsStor',
                    data: {
                        BoxId: that.boxId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    that.boxId=data.BoxId;
                    that.boxCode = data.Code + '/' + data.Name;
                    that.phholder = '请扫码商品标签';
                    that.loading = false;
                })
                .catch(() => {
                    that.firstScanSpace = true;
                    that.loading = false;
                });
        },
        removeLabel(index, row) {
            let that = this;
            if (that.dataList.length != 0) {
                that.dataList.splice(index, 1);
            }
        },
        // 失去焦点
        inputblur() {
            let that = this;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            setTimeout(() => {
                if (that.$refs.inputdata) that.$refs.inputdata.focus();
            }, 100);
        },
        inputDataChange() {
            let that = this;
            if (that.scanData.indexOf('AP-') > -1) {
                if(!that.boxId){
                    that.$util.warningMsg('请先扫箱子标签');
                    return;
                }
                if (that.scanData.length == 20) {
                    let box = that.dataList.find(x => x.LabelCode == that.scanData);
                    if (box) {
                        that.$util.warningMsg('重复标签！');
                        that.aplayAudio(that.repetLabel);
                        that.scanData = '';
                        return;
                    }
                    that.$util
                        .axiosGet({
                            url: '/api/EntpBoxes/CheckLabel',
                            data: {
                                LabelCode: that.scanData,
                                BoxId: that.boxId
                            }
                        })
                        .then(res => {
                            let data = res.data;
                            if (data) {
                                let box = that.dataList.find(x => x.LabelCode == data.LabelCode);
                                if (box) {
                                    that.$util.warningMsg('重复标签！');
                                    that.aplayAudio(that.repetLabel);
                                    return;
                                }
                                that.dataList.push(data);
                            } else {
                                that.aplayAudio(that.errorAudio);
                            }
                        })
                        .catch(() => {
                            that.aplayAudio(that.errorAudio);
                        });
                } else {
                    that.aplayAudio(that.errorAudio);
                    that.$util.warningMsg('标签编码长度不符合规则！请检查输入法是否为英文输入法');
                }
            } else if (that.scanData.length > 0) {
                that.boxId = that.scanData;
                if (that.firstScanSpace) {
                    that.firstScanSpace = false;
                    that.checkBoxForGoodsStor();
                } else {
                    that.$confirm('确定要切换存放的箱子吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            that.firstScanSpace = true;
                            that.boxCode = '';
                            that.boxId = '';
                            that.phholder = '请扫箱子标签';
                            that.checkBoxForGoodsStor();
                        })
                        .catch(() => {});
                }
            } else {
                that.aplayAudio(that.errorAudio);
                that.$util.warningMsg('标签码长度不符合规则！请检查输入法是否为英文输入法');
            }
            that.scanData = '';
        },
        submit() {
            let that = this;
            if (that.dataList.length == 0) {
                that.$util.warningMsg('无商品标签信息，请重新扫码');
                return;
            }
            that.$confirm('确定提交入箱吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            }).then(() => {
                this.loading = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpBoxes/GoodsScanInBox',
                        data: {
                            BoxId: that.boxId,
                            Labels: that.dataList
                        }
                    })
                    .then(res => {
                        that.$util.successMsg('入箱成功');
                        that.aplayAudio(that.submitSuccessAudio);
                        that.firstScanSpace = true;
                        that.dataList = [];
                        that.boxCode = '';
                        that.boxId = '';
                        that.phholder = '请扫箱子标签';
                        that.loading = false;
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            });
        },
        aplayAudio(audioUrl) {
            this.$refs.audio.src = audioUrl;
            this.$nextTick(res => {
                this.$refs.audio.load();
                this.$refs.audio.play();
            });
        }
    }
};
</script>
<style lang="less" scoped>
.labelzone {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    padding-left: 20px;
    width: 100%;
    height: 100%;
    margin-bottom: 30px;
}
.labelk {
    display: flex;
    flex-direction: column;
}
.box-card {
    width: 220px;
    margin: 5px;
}

.time {
    font-size: 13px;
    color: #999;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}

.clearfix:after {
    clear: both;
}

.goodname {
    font-size: 18px;
    line-height: 24px;
}
.apcode {
    font-size: 15px;
}
.check-class {
    color: red;
    font-weight: bold;
}
.check-class-enough {
    color: green;
    font-weight: bold;
}
</style>
